export default defineNuxtPlugin({
  name: 'app:fetch-instance',

  setup() {
    function createInstance() {
      const instance = $fetch.create({
        async onRequest() {},
        async onRequestError() {},
        async onResponse() {},
        async onResponseError() {},
      })

      return {
        instance,
      }
    }

    const fetchInstance = createInstance().instance

    return {
      provide: {
        fetchPlugin: {
          fetchInstance,
        },
      },
    }
  },
})
